import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { injectIntl } from 'react-intl'

import { Game, Firebase } from '../../../Core'

import * as actions from '../battles.actions'
import * as audioActions from '../../../Core/Game/AudioContainer/audio.actions'
import * as selectors from '../battles.selectors'

import StartBattle from './StartBattle'

const mapDispatchToProps = (dispatch) => {
  return {
    getBattleQuestion: bindActionCreators(actions.getBattleQuestion, dispatch),
    giveUp: bindActionCreators(actions.giveUp, dispatch),
    removeScreen: bindActionCreators(Game.actions.removeScreen, dispatch),
    addScreen: bindActionCreators(Game.actions.addScreen, dispatch),
    addHowlSound: bindActionCreators(audioActions.playHowlAudio, dispatch),
    removePopup: bindActionCreators(Game.actions.removePopup, dispatch),
  }
}
const mapStateToProps = (state) => {
  return {
    currentUser: Firebase.selectors.getUserData(state),
    rivalInfo: selectors.getRivalInfo(state),
    battle: selectors.getCurrentBattle(state),
    individualBattle: selectors.getIndividualBattle(state),
    rankingObfuscated: Firebase.selectors.getObfuscatedRankingFlag(state),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(StartBattle))
